export type EditingMode = "create" | "read" | "edit";

export function toggleEditMode(mode: EditingMode): EditingMode {
  return mode === "edit" ? "read" : "edit";
}
